module.exports = __webpack_public_path__ + "media/images/bg-gold-e252ebb0e1a559513432a3375f314df2.jpg";